
import './modal.scss';

import { gsap } from "gsap";


export class Modal {

	wrapper: HTMLElement;
	overlay: HTMLElement;
	mainContent: HTMLElement;

	openTrigger: HTMLElement;
	closeTrigger: HTMLButtonElement;

	overlayTween: any;
	closeTriggerTween: any;
	mainContentTween: any;



	constructor(openTrigger: HTMLElement, wrapper: HTMLElement) {
		this.openTrigger = openTrigger;
		this.wrapper = wrapper;

		this.overlay      = this.wrapper.querySelector('.modal-blue-layer');
		this.closeTrigger = this.wrapper.querySelector('.modal-close');
		this.mainContent  = this.wrapper.querySelector('.modal-content-layer');

		this.resetModal();
		this.setupModalTweens();

		if ( this.openTrigger ) {
			this.openTrigger.addEventListener('click', (ev: MouseEvent) => {
				ev.preventDefault();

				this.openModal();
			});
		}

		if ( this.closeTrigger ) {
			this.closeTrigger.addEventListener('click', (ev: MouseEvent) => {
				ev.preventDefault();

				this.closeModal();
			});
		}

	}


	resetModal() {
		if ( this.overlay ) {
			this.overlay.style.left    = '-100%';
			this.overlay.style.opacity = '0';
		}

		if ( this.closeTrigger ) {
			this.closeTrigger.style.opacity = '0';
		}

		if ( this.mainContent ) {
			this.mainContent.style.left = '100%';
			this.mainContent.style.opacity = '0';
		}
	}


	setupModalTweens() {

		if ( this.overlay ) {
			this.overlayTween = gsap.to(this.overlay, {
				duration: .7,
				left: 0,
				opacity: 1,
				paused: true
			});
		}

		if ( this.closeTrigger ) {
			this.closeTriggerTween = gsap.to(this.closeTrigger, {
				duration: .7,
				opacity: 1,
				delay: .3,
				paused: true
			});
		}

		if ( this.mainContent ) {

			let spacer = 25 + 'px';

			if (window.innerWidth > 375 ) {
				spacer = 100 + 'px';
			}

			if (window.innerWidth > 1024 ) {
				spacer = 290 + 'px';
			}

			if (window.innerWidth >= 1440 ) {
				spacer = '50%';
			}

			this.mainContentTween = gsap.to(this.mainContent, {
				duration: .7,
				left: spacer,
				opacity: 1,
				paused: true,
				onComplete: () => {
					document.querySelectorAll('body').forEach( (el: HTMLElement) => el.classList.add('modal-open') );
				},
				onReverseComplete: () => {
					this.wrapper.classList.add('hidden');
					this.wrapper.classList.remove('active');
					document.querySelectorAll('body').forEach( (el: HTMLElement) => el.classList.remove('modal-open') );
					this.resetModal();
				},
			});
		}

	}


	openModal() {
		this.wrapper.classList.remove('hidden');
		this.wrapper.classList.add('active');

		if ( this.overlayTween ) {
			this.overlayTween.play();
		}

		if ( this.closeTriggerTween ) {
			this.closeTriggerTween.play();
		}

		if ( this.mainContentTween ) {
			this.mainContentTween.play();
		}

	}


	closeModal() {

		if ( this.overlayTween ) {
			this.overlayTween.reverse();
		}

		if ( this.closeTriggerTween ) {
			this.closeTriggerTween.reverse();
		}

		if ( this.mainContentTween ) {
			this.mainContentTween.reverse();
		}

	}

}